import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBtLmJBI0nLxP8lv9b6RytcAmGHZYTgxdA',
  authDomain: 'uve-eagle-raw.firebaseapp.com',
  projectId: 'uve-eagle-raw',
  storageBucket: 'uve-eagle-raw.firebasestorage.app',
  messagingSenderId: '591613847672',
  appId: '1:591613847672:web:9c8678f23b29b0ce1c258d',
  measurementId: 'G-5QBH130EN5',
};

const app = initializeApp(firebaseConfig);

// eslint-disable-next-line import/no-mutable-exports
let messaging: Messaging | null = null;

try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn('Messaging is not supported');
  console.warn(e);
}

const analytics = getAnalytics(app);

export { messaging, analytics };
